import { Button } from '@loadsmart/loadsmart-ui'

import { hasBid } from '../domain/LaneProposal'
import {
  ProposalSubmitState,
  getProposalSubmitState,
  hasRunningProcess,
  type Proposal,
} from '../domain/Proposal'
import { useRfpContext } from './contexts/RfpContext'

export type RfpSubmitButtonType = {
  proposal: Proposal
  disabled?: boolean
  isLoading: boolean
  onSubmit: () => void
  onChangeProposal: () => void
  onWithdraw: () => void
}

export function RfpSubmitButton({
  proposal,
  disabled = false,
  isLoading,
  onSubmit,
  onChangeProposal,
  onWithdraw,
}: RfpSubmitButtonType) {
  const {
    state: { laneProposalIds },
  } = useRfpContext()

  const state = getProposalSubmitState(proposal)

  if (state === ProposalSubmitState.Open) {
    const isSubmitDisabled =
      disabled || isLoading || !hasBid(laneProposalIds) || hasRunningProcess(proposal)

    return (
      <Button disabled={isSubmitDisabled} variant="primary" onClick={onSubmit} loading={isLoading}>
        Submit
      </Button>
    )
  }

  if (state === ProposalSubmitState.Negotiating) {
    const isChangeDisabled = disabled || isLoading
    return (
      <Button
        disabled={isChangeDisabled}
        variant="primary"
        onClick={onChangeProposal}
        loading={isLoading}
      >
        Change Offer
      </Button>
    )
  }

  if (state === ProposalSubmitState.Submitted) {
    const isWithdrawDisabled = disabled || isLoading

    return (
      <Button
        disabled={isWithdrawDisabled}
        variant="secondary"
        onClick={onWithdraw}
        loading={isLoading}
      >
        Withdraw Offer
      </Button>
    )
  }

  return (
    <Button variant="secondary" disabled>
      Bids Ended
    </Button>
  )
}
